/**
 * @fileoverview Loading placeholder for the Capabilities matrix.
 * @description Two module-card shells with placeholder rows, approximating the real tables'
 * proportions (a wide name column and one narrow column per role) so the page doesn't jump when
 * the matrix arrives.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import Skeleton from '@/shared/components/atoms/Skeleton'

const CARDS = 2
const ROWS = 4
const ROLE_COLUMNS = 4

/**
 * @component
 */
function CapabilitiesSkeleton() {
  return (
    <div className="flex flex-col gap-4" data-testid="capabilities-skeleton">
      {Array.from({ length: CARDS }, (_, card) => (
        <section key={card} className="rounded-[10px] border border-divider bg-white">
          <div className="px-4 pt-4 pb-3">
            <Skeleton width={180} height={16} />
          </div>
          <div className="border-t border-divider">
            {Array.from({ length: ROWS }, (_, row) => (
              <div
                key={row}
                className="grid items-center gap-3 border-b border-row-border px-4 py-3.5 last:border-b-0"
                style={{ gridTemplateColumns: `2fr repeat(${ROLE_COLUMNS}, minmax(0, 1fr))` }}
              >
                <Skeleton width="70%" height={13} />
                {Array.from({ length: ROLE_COLUMNS }, (_, col) => (
                  <Skeleton key={col} height={28} />
                ))}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}

export default CapabilitiesSkeleton
